var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-container" },
    [
      _c(
        "div",
        { staticClass: "d-flex align-items-center w-100" },
        [
          _c("h5", { staticClass: "mb-0" }, [_vm._v("Медиафайлы")]),
          _vm._v(" "),
          _vm.canEditMedia
            ? _c(
                "b-button",
                {
                  staticClass: "custom-btn-primary ml-auto",
                  attrs: { disabled: _vm.isBusy || _vm.isDisabled },
                  on: { click: _vm.onAdd }
                },
                [
                  _c("v-icon", { attrs: { name: "buttons/plus", size: 12 } }),
                  _vm._v("\n      Добавить\n    ")
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-body" },
        [
          _c(
            "b-row",
            { staticStyle: { gap: "24px" } },
            _vm._l(_vm.items, function(item, index) {
              return _c(
                "b-col",
                { key: item.id, attrs: { cols: "12", xl: "4" } },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "adaptive-card custom-card h-100",
                      attrs: { "no-body": "" },
                      on: {
                        click: function($event) {
                          return _vm.onEdit(index)
                        }
                      }
                    },
                    [
                      _c(
                        "b-card-body",
                        { staticClass: "d-flex flex-column" },
                        [
                          _c(
                            "b-row",
                            { staticClass: "mb-2" },
                            [
                              _c("b-col", [
                                _c("h5", { staticClass: "mb-0" }, [
                                  _vm._v(_vm._s(item.title))
                                ])
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            {
                              staticClass:
                                "mb-1 flex-grow-1 text-small text-muted text-clamp"
                            },
                            [
                              _c("b-col", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(item.description || "Нет описания") +
                                    "\n              "
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-row", { staticClass: "px-3" }, [
                            item.isLoadingFiles
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "media-preview-row d-flex align-items-center justify-content-center bg-light rounded text-muted small"
                                  },
                                  [
                                    _c("b-spinner", {
                                      staticClass: "mr-2",
                                      attrs: { small: "", variant: "success" }
                                    }),
                                    _vm._v(" "),
                                    _c("small", [_vm._v("Загрузка файлов...")])
                                  ],
                                  1
                                )
                              : item.files.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "media-preview-row d-flex" },
                                  [
                                    _vm._l(item.files, function(file, index) {
                                      return [
                                        index < 3
                                          ? _c(
                                              "div",
                                              {
                                                key: index,
                                                staticClass:
                                                  "media-preview-col mr-1 position-relative border"
                                              },
                                              [
                                                !file.hasError
                                                  ? _c("div", [
                                                      file.type.startsWith(
                                                        "video"
                                                      )
                                                        ? _c("video", {
                                                            staticClass:
                                                              "media-obj",
                                                            attrs: {
                                                              src: file.url,
                                                              preload:
                                                                "metadata"
                                                            },
                                                            on: {
                                                              error: function(
                                                                $event
                                                              ) {
                                                                return _vm.$set(
                                                                  file,
                                                                  "hasError",
                                                                  true
                                                                )
                                                              }
                                                            }
                                                          })
                                                        : _c("img", {
                                                            staticClass:
                                                              "media-obj",
                                                            attrs: {
                                                              src: file.url,
                                                              alt: "img"
                                                            },
                                                            on: {
                                                              error: function(
                                                                $event
                                                              ) {
                                                                return _vm.$set(
                                                                  file,
                                                                  "hasError",
                                                                  true
                                                                )
                                                              }
                                                            }
                                                          })
                                                    ])
                                                  : _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "h-100 w-100 d-flex flex-column align-items-center justify-content-center text-muted"
                                                      },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass:
                                                              "mb-1 text-danger",
                                                            attrs: {
                                                              icon:
                                                                "exclamation-circle"
                                                            }
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _c("small", [
                                                          _vm._v(
                                                            "Ошибка загрузки"
                                                          )
                                                        ])
                                                      ],
                                                      1
                                                    ),
                                                _vm._v(" "),
                                                index === 2 &&
                                                item.files.length > 3
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "more-overlay"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      +" +
                                                            _vm._s(
                                                              item.files
                                                                .length - 3
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    })
                                  ],
                                  2
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "media-preview-row d-flex align-items-center justify-content-center bg-light rounded text-muted small"
                                  },
                                  [_c("small", [_vm._v("Нет файлов")])]
                                )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }),
            1
          ),
          _vm._v(" "),
          _vm.items.length === 0
            ? _c(
                "div",
                { staticClass: "empty-state-container" },
                [
                  _c("v-icon", {
                    attrs: { name: "navbar/empty_table", size: 90 }
                  }),
                  _vm._v(" "),
                  _c("h5", [_vm._v("Нет добавленных медиафайлов.")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("Добавьте новые файлы прямо сейчас")]),
                  _vm._v(" "),
                  _vm.canEditMedia
                    ? _c(
                        "b-btn",
                        {
                          staticClass: "custom-btn-primary mt-1",
                          attrs: { disabled: _vm.isBusy || _vm.isDisabled },
                          on: { click: _vm.onAdd }
                        },
                        [
                          _c("v-icon", {
                            staticClass: "mr-1",
                            attrs: { name: "buttons/plus", size: 12 }
                          }),
                          _vm._v("\n        Новый файл\n      ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modal_media",
          attrs: {
            id: "modal-media",
            size: "xl",
            title:
              _vm.mediaItem.id === 0
                ? "Новая запись"
                : 'Редактирование медиафайлов "' + _vm.mediaItem.title + '".',
            centered: "",
            scrollable: "",
            "ok-only": true,
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          },
          on: { hidden: _vm.cleanUpModal },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _vm.canEditMedia && _vm.isEditing
                    ? _c(
                        "b-button",
                        {
                          staticClass: "custom-btn-danger",
                          attrs: { disabled: _vm.isDisabled },
                          on: {
                            click: function($event) {
                              return _vm.onRemoveMedia()
                            }
                          }
                        },
                        [_vm._v("\n        Удалить\n      ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "custom-btn-secondary",
                      on: {
                        click: function($event) {
                          return _vm.hideModal()
                        }
                      }
                    },
                    [_vm._v("\n        Отмена\n      ")]
                  ),
                  _vm._v(" "),
                  _vm.canEditMedia
                    ? _c(
                        "b-button",
                        {
                          staticClass: "custom-btn-primary",
                          attrs: { disabled: _vm.isDisabled },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.handleSubmit()
                            }
                          }
                        },
                        [_vm._v("\n        Сохранить\n      ")]
                      )
                    : _vm._e()
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.showModalMediaItems,
            callback: function($$v) {
              _vm.showModalMediaItems = $$v
            },
            expression: "showModalMediaItems"
          }
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Заголовок" } },
                    [
                      _c("b-form-input", {
                        attrs: {
                          disabled: _vm.isDisabled || !_vm.canEditMedia,
                          size: "sm",
                          type: "text",
                          placeholder: "Введите заголовок"
                        },
                        model: {
                          value: _vm.mediaItem.title,
                          callback: function($$v) {
                            _vm.$set(_vm.mediaItem, "title", $$v)
                          },
                          expression: "mediaItem.title"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Описание" } },
                    [
                      _c("b-form-textarea", {
                        attrs: {
                          disabled: _vm.isDisabled || !_vm.canEditMedia,
                          placeholder: "Нет описания",
                          size: "sm",
                          rows: "3"
                        },
                        model: {
                          value: _vm.mediaItem.description,
                          callback: function($$v) {
                            _vm.$set(_vm.mediaItem, "description", $$v)
                          },
                          expression: "mediaItem.description"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Файлы" } },
                    [
                      _vm.canEditMedia
                        ? _c("b-form-file", {
                            ref: "mediaFileInput",
                            attrs: {
                              multiple: "",
                              disabled: _vm.isDisabled,
                              size: "sm",
                              placeholder: "Файлы не выбраны",
                              "browse-text": "Выбрать",
                              accept:
                                "image/*,video/*,.pdf,.xlsx,.xls,.doc,.docx,.txt"
                            },
                            on: { change: _vm.handleUpload }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            _vm._l(_vm.mediaItem.files, function(file, index) {
              return _c(
                "b-col",
                {
                  key: index,
                  staticClass: "mt-4 position-relative",
                  attrs: { cols: "4" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "modal-media-size border rounded overflow-hidden position-relative"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "modal-media-position",
                          on: {
                            click: function($event) {
                              !file.hasError ? _vm.openMediaView(file) : null
                            }
                          }
                        },
                        [
                          !file.hasError
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "h-100 w-100 d-flex align-items-center justify-content-center cursor-pointer"
                                },
                                [
                                  file.category === "video"
                                    ? _c("video", {
                                        staticClass: "media-obj",
                                        attrs: {
                                          src: file.url,
                                          preload: "metadata"
                                        },
                                        on: {
                                          error: function($event) {
                                            return _vm.$set(
                                              file,
                                              "hasError",
                                              true
                                            )
                                          }
                                        }
                                      })
                                    : file.category === "image"
                                    ? _c("img", {
                                        staticClass: "media-obj",
                                        attrs: { src: file.url, alt: "img" },
                                        on: {
                                          error: function($event) {
                                            return _vm.$set(
                                              file,
                                              "hasError",
                                              true
                                            )
                                          }
                                        }
                                      })
                                    : _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-muted d-flex flex-column align-items-center w-100 px-3 text-center"
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            staticClass: "mb-2",
                                            attrs: {
                                              icon: _vm.getFileIcon(
                                                file.fileName
                                              ),
                                              size: "3x"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "small",
                                            {
                                              staticClass: "text-truncate w-100"
                                            },
                                            [_vm._v(_vm._s(file.fileName))]
                                          )
                                        ],
                                        1
                                      )
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass:
                                    "h-100 w-100 d-flex align-items-center justify-content-center text-muted pl-3"
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-2 text-danger",
                                    attrs: {
                                      icon: "exclamation-circle",
                                      size: "lg"
                                    }
                                  }),
                                  _vm._v(
                                    "\n              Ошибка загрузки\n            "
                                  )
                                ],
                                1
                              )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.canEditMedia
                    ? _c(
                        "b-button",
                        {
                          staticClass:
                            "p-1 remove-btn-position rounded-circle d-flex align-items-center justify-content-center",
                          attrs: {
                            variant: "danger",
                            size: "sm",
                            disabled: _vm.isDisabled
                          },
                          on: {
                            click: function($event) {
                              return _vm.onRemoveFile(index)
                            }
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "times-circle" }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass:
                        "p-1 download-btn-position rounded-circle d-flex align-items-center justify-content-center",
                      attrs: {
                        variant: "info",
                        size: "sm",
                        href: file.url,
                        download: file.fileName
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        staticStyle: { "font-size": "12px" },
                        attrs: { icon: "download" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-passport-file-view",
            size: "xl",
            centered: "",
            "hide-footer": "",
            "hide-header": "",
            "body-class": "p-0 bg-dark"
          },
          model: {
            value: _vm.showMediaViewModal,
            callback: function($$v) {
              _vm.showMediaViewModal = $$v
            },
            expression: "showMediaViewModal"
          }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-center align-items-center position-relative",
              staticStyle: { "min-height": "50vh" }
            },
            [
              _c(
                "b-button",
                {
                  staticClass: "view-btn-position text-white position-absolute",
                  attrs: { variant: "link" },
                  on: {
                    click: function($event) {
                      return _vm.hideMediaView()
                    }
                  }
                },
                [_c("font-awesome-icon", { attrs: { icon: "times" } })],
                1
              ),
              _vm._v(" "),
              _vm.viewFile && _vm.viewFile.type.startsWith("video")
                ? _c("video", {
                    staticClass: "w-100 h-auto view-media-height",
                    attrs: { controls: "", autoplay: "", src: _vm.viewFile.url }
                  })
                : _vm.viewFile
                ? _c("img", {
                    staticClass: "img-fluid view-media-height",
                    attrs: { src: _vm.viewFile.url, alt: "view" }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25ef943f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25ef943f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/utilites/commonUi/Media.vue
// module id = null
// module chunks = 